//import Begro from "../../Begro";

/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:16/01/2021
 @Time:08:00
 **/

import ProduitPaquet from './ProduitPaquet';
import ProduitEtiquette from "./ProduitEtiquette";
import LangueService from "../../../i18n/service/LangueService";
import TranslationService from "../../../i18n/service/TranslationService";
import {Notice} from "../../../vendors/begro/dialog-et-notice";

export default class Produit {


    /**
     * @type {string}
     */
    #id = null;


    /**
     *
     * @type {boolean}
     * @private
     */
    #_subventionne = false;


    /**
     * si le produit subventionne est contrôlé
     * @type {boolean}
     * @private
     */
    #_subventionneControle = false;

    /**
     * indique si le produit est un service ou produit de commerce
     * @type {boolean}
     * @private
     */
    #_service=false;

    /**
     * indique si le service est facturable par heure ou non
     * @type {boolean}
     * @private
     */
    #_serviceFacturableParHeure=false;


    /**
     *
     * @type {string[]}
     * @private
     */
    #traductions = [];
    /**
     *
     * @type {number}
     * @private
     */
    #prix = 0;
    /**
     *
     * @type {number}
     * @private
     */
    #taxe = 0;
    /**
     *
     * @type {ProduitPaquet[]}
     * @private
     */
    #produitPaquets = [];

    /**
     *
     * @type {string}
     * @private
     */
    #codeBarres = null;

    /**
     * Le stock associé au produit pour la société de l'utilisateur connecté
     * @type {Stock}
     */
    #stock = null;


    /**
     * drapeau qui indique que le stock est deja en cours de refraichissement ou non
     * @type {boolean}
     * @private
     */
    #stockInRefreshFlag = false;

    /**
     * le paquetage d'un produit pour une utilisation avec liste de choix
     * @type {String[]}
     * @private
     */
    #paquetagePourListeChoix = [];

    /**
     * Les etiquettes et leurs traductions
     * @type {Object<string,ProduitEtiquette>}
     * @private
     */
    #_etiquettes = {};


    /**
     * retourne le paquetage d'un produit pour une utilisation dans une liste de choix
     * @returns {String[]}
     */
    get paquetagePourListeChoix() {
        return this.#paquetagePourListeChoix;
    }

    /**
     *
     * @param {string} locale - locale format frFR
     * @param {string} designationProduit la designation du produit
     */
    addTraduction(locale, designationProduit) {
        this.#traductions[locale] = designationProduit;
    }

    /**
     *
     * @param {ProduitPaquet} produitPaquet - le paquet de produit qu'on veut ajouter
     */
    addProduitPaquet(produitPaquet) {
        this.#produitPaquets[produitPaquet.id] = produitPaquet;
        this.#paquetagePourListeChoix[produitPaquet.id] = produitPaquet.quantite;
    }

    /**
     * Retourne Une etiquette pour le produit
     * @param id
     * @param locale
     * @return {null|ProduitEtiquette}
     */
    getEtiquette(id) {
        return this.#_etiquettes[id] !== undefined ? this.#_etiquettes[id] : null;
    }

    addEtiquette(etiquette) {
        this.#_etiquettes[etiquette.id] = etiquette;
    }


    getEtiquettes() {
        return this.#_etiquettes;
    }

    /**
     *
     * @param {ProduitPaquet}produitPaquet
     */
    removeProduitPaquet(produitPaquet) {
        this.#produitPaquets[produitPaquet.id] !== undefined ? delete this.#produitPaquets[produitPaquet.id] : null;
        this.#paquetagePourListeChoix[produitPaquet.id] !== undefined ? delete this.#paquetagePourListeChoix[produitPaquet.id] : null;
    }

    /**
     * retourne la traduction
     * @param locale
     * @returns {string}
     */
    getDesignation(locale) {
        return this.#traductions[locale] || "";
    }

    /**
     * @param {string}id - UUID du produit
     */
    set id(id) {
        this.#id = id;
    }

    get id() {
        return this.#id;
    }

    /**
     *
     * @param {number}prix
     */
    set prix(prix) {
        this.#prix = prix;
    }

    /**
     *
     * @returns {number}
     */
    get prix() {
        return this.#prix;
    }


    get service() {
        return this.#_service;
    }

    set service(value) {
        this.#_service = value;
    }


    /**
     * le service est facturable par heure ou non
     * @return {boolean}
     */
    get serviceFacturableParHeure() {
        return this.#_serviceFacturableParHeure;
    }

    /**
     *
     * @param {boolean} value true si le service est facturable par heure
     */
    set serviceFacturableParHeure(value) {
        this.#_serviceFacturableParHeure = value;
    }

    /**
     *
     * @param {number}taxe
     */
    set taxe(taxe) {
        this.#taxe = taxe;
    }

    /**
     * @returns {number}
     */
    get taxe() {
        return this.#taxe;
    }

    /**
     *
     * @param {string} codeBarres
     */
    set codeBarres(codeBarres) {
        this.#codeBarres = codeBarres;
    }

    get codeBarres() {
        return this.#codeBarres;
    }

    get produitPaquets() {
        return this.#produitPaquets;
    }

    /**
     * retourne le nombre de paquet disponible pour le produit
     * @return {number}
     */
    produitPaquetCount(){
        return Object.keys(this.#produitPaquets).length;
    }

    /**
     *
     * @param {string} id - identifiant du produit paquet
     * @returns {ProduitPaquet|null}
     */
    getProduitPaquetById(id) {
        return (this.#produitPaquets[id] !== undefined) ? this.#produitPaquets[id] : null;
    }


    get subventionne() {
        return this.#_subventionne;
    }

    set subventionne(value) {
        this.#_subventionne = value;
    }

    get subventionneControle() {
        return this.#_subventionneControle;
    }

    set subventionneControle(value) {
        this.#_subventionneControle = value;
    }

    /**
     * @param {Stock}stock
     */
    set stock(stock) {
        this.#stock = stock;
    }

    get stock() {
        //faire une requette ajax pour récupérer le stock associé au produit et lancer un évènement StockProduitAvailable
        if (this.#stock === null) {
            this.refreshStock();
        }
        return this.#stock;
    }

    /**
     * return prix ttc
     * @return {number}
     */
    getPrixTTC(){
        return this.#prix+((this.prix*this.#taxe)/100);
    }

    /**
     * Important a ne pas utiliser cette méthode à l'intérieur de cette classe
     * @param stockInRefreshFlag
     */
    set stockInRefreshFlag(stockInRefreshFlag) {
        this.#stockInRefreshFlag = stockInRefreshFlag;
    }

    //methode qui permet de refraichir le stock associé au produit
    refreshStock() {
        if (!this.#stockInRefreshFlag) {
            let produit = this;
            produit.stockInRefreshFlag = true;
            $.ajax({
                method: "GET",
                url: Begro.getURL("stock/get-par-produit/") + this.id,
                success: function (stockJson) {
                    produit.stock = Stock.createStockFromJson(stock);
                    //lancer un évènement qui indique que le stock associé a un produit est récupéré
                    document.dispatchEvent(new CustomEvent('stockAvailable', {
                        'stock': stock
                    }));
                    produit.stockInRefreshFlag = false;// mettre le drapeau en cours de refraichissement a faux
                }
            });
        }
    }

    /**
     * méthode qui permet de chercher un produit et de lancer une méthode rappel une fois il devient disponible
     * @param {string} codeBarre - code a barre du produit
     * @param {function} callback - fonction de rappel qui sera appelé aprés la récupération du produit ayant code a barre rèçu en paramètre
     */
    static getByCodeBarres(codeBarre, callback) {
        let produit = null;
        $.get({
            url: Begro.getURL("produit/get-by-code-barre"),
            data: {"code_barre": codeBarre},
            success: function (data) {
                produit = Produit.createProduitFromJson(data);
                if (typeof callback === "function") {
                    callback(produit);
                }
            }, statusCode: {
                404: function () {
                    Notice.warning(TranslationService.getInstance().translate('produit:feedback.aucun_produit_ayant_code_barres_x', {"codeBarre": codeBarre}));
                }
            }
        });
    }


    /**
     * méthode qui permet de chercher un produit et de lancer une méthode rappel une fois il devient disponible
     * @param {string} id - id du produit
     * @param {function} callback - fonction de rappel qui sera appelé aprés la récupération du produit ayant code a barre rèçu en paramètre
     */
    static getById(id, callback) {
        let produit = Begro.getProduitByID(id);
        if(produit===null) {
            $.get({
                url: Begro.getURL("produit/get-by-id"),
                data: {"id": id},
                success: function (data) {
                    produit = Produit.createProduitFromJson(data);
                    if (typeof callback === "function") {
                        callback(produit);
                    }
                }, statusCode: {
                    404: function () {
                        Notice.warning(TranslationService.getInstance().translate('produit:feedback.aucun_produit_ayant_id_x', {"id": id}));
                    }
                }
            });
        }else{
            if (typeof callback === "function") {
                callback(produit);
            }
        }
    }

    /**
     * Methode qui essayes de retourné u objet produit déja crée et existe dans l'insatnce de  classe begro sinon on crée un objet produit depuis un objet produit json céer JKSON Stringify et le mémorise dans begro
     * @param jsonProduit
     * @returns {Produit}
     */
    static createProduitFromJson(jsonProduit) {
        let activeLocale = LangueService.getInstance().activeLangue.locale;
        let produit = Begro.getProduitByID(jsonProduit.id);
        if (!produit) {
            Begro.logInfo("=============Début création nouvelle instance du produit " + jsonProduit.produitTraductions[activeLocale].designation + " - " + jsonProduit.id + "=============");
            Begro.logInfo("objet json original");
            Begro.logInfo(JSON.stringify(jsonProduit, null, 2));
            produit = new Produit();
            produit.id = jsonProduit.id;
            produit.subventionne = jsonProduit.subventionne;
            produit.subventionneControle = jsonProduit.subventionneControle
            produit.taxe = jsonProduit.taxe ? jsonProduit.taxe.value : 0;
            produit.service=jsonProduit.service;
            produit.codeBarres = jsonProduit.codeBarre;
            produit.serviceFacturableParHeure=jsonProduit.serviceFacturableParHeure;
            produit.prix = jsonProduit.prix;
            //ajouter les traductions pour la designation du produit
            if(jsonProduit.hasOwnProperty('produitTraductions')) {
                for (let locale in jsonProduit.produitTraductions) {
                    produit.addTraduction(locale, jsonProduit.produitTraductions[locale].designation)
                }
            }
            if (jsonProduit.hasOwnProperty("paquets") && jsonProduit.paquets instanceof Array) {
                for (let i = 0; i < jsonProduit.paquets.length; i++) {
                    if (jsonProduit.paquets[i].id !== null) {// pour ne pas ajouter la ligne template si stock est crée depuis via a l'affichage de vue stock
                        Begro.env !== "dev"
                        || console.log("----début Ajout d'une ligne Produit Paquet  " + " - " + jsonProduit.paquets[i].id + "-----")
                        let produitPaquet = ProduitPaquet.createProduitPaquetFromJson(jsonProduit.paquets[i]);
                        produitPaquet.produit = produit;
                        produit.addProduitPaquet(produitPaquet);
                        Begro.env !== "dev"
                        || console.log("----Fin ajout d'une ligne Produit Paquet  " + produitPaquet.getDesignation(activeLocale) + " - " + produitPaquet.id + "----")
                    }
                }
            }

            //ajouter les étiquettes
            if (jsonProduit.hasOwnProperty("etiquettes") && jsonProduit.etiquettes instanceof Array) {
                for (let i = 0; i < jsonProduit.etiquettes.length; i++) {
                    let etiquette = jsonProduit.etiquettes[i];
                    produit.addEtiquette(ProduitEtiquette.createFromJson(etiquette));
                }
            }
            //ajouter begro au conteneur globale
            Begro.addProduit(produit);
            Begro.env !== "dev"
            ||
            console.log("=============Fin création nouvelle instance du produit " + produit.getDesignation(activeLocale) + " - " + produit.id + "=============")
            ||
            console.log("==> Le nouveau produit " + produit.getDesignation(activeLocale) + " - " + produit.id + " est ajouté au conteneur globale Begro");
        } else {
            Begro.logInfo("Le produit " + produit.getDesignation(activeLocale) + " est retiré depuis le conteneur globale Begro");
        }
        return produit;
    }

    /**
     * Méthode qui permet retourner un tableau des produits depuis un json
     * @param jsonProduitArray array de json de type Produit serailisé via spring
     * @return {Produit[]}
     */
    static createProduitListFromJson(jsonProduitArray) {
        let produitList = [];
        for (let i in jsonProduitArray) {
            produitList.push(Produit.createProduitFromJson(jsonProduitArray[i]));
        }
        return produitList;
    }
}